export default {
  RESET_SEARCH: ({ commit }) => {
    commit('SET_START_AT', 0);
    commit('SET_CONFLUENCE_OPENED_INDEX', -1);
    commit('SET_COMMENT_OPENED_INDEX', -1);
    commit('SET_CURRENT_PAGE', 1);
    commit('SET_CONFLUENCE_PAGE_INCREMENT', 1);
    commit('SET_JIRA_PAGE_INCREMENT', 1);
    commit('SET_TRANSITION', 'list-left');
    commit('SET_SHOW_ANNOUNCEMENT', false);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js